import loadable from '@loadable/component'

export default [
  {
    path: '/coinagency/signup',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-CoinagencySignup" */ '~/pages/Coinagency/Signup'
        )
    ),
  },
  {
    path: '/coinagency/invitation',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-CoinagencyInvitation" */ '~/pages/Coinagency/Invitation'
        )
    ),
  },
  {
    path: '/coinagency/agencywallet',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-CoinagencyAgencyWallet" */ '~/pages/Coinagency/AgencyWallet'
        )
    ),
  },
  {
    path: '/coinagency/recharge',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-CoinagencyAgencyRecharge" */ '~/pages/Coinagency/AgencyRecharge'
        )
    ),
  },
  {
    path: '/coinagency/sell/:restCurrency',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-CoinagencyAgencySellCoins" */ '~/pages/Coinagency/SellCoins'
        )
    ),
  },
  {
    path: '/coinagency/distributorManage',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-CoinagencyDistributorManage" */ '~/pages/Coinagency/DistributorManage'
        )
    ),
  },
  // 超级币商分销页面
  {
    path: '/coinagency/DistributorManageSuper',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-CoinagencyDistributorManageHighest" */ '~/pages/Coinagency/DistributorManageSuper'
        )
    ),
  },
]
